// initialize jquery ajax options
$(document).ready(function() {
	$.ajaxSetup({
		headers: {
			// add the CSRF token to all ajax requests
			'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
		}
	});
});
